"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuPortal = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactSelect = require("react-select");
var _LayoutContext = require("./LayoutContext");
const MenuPortal = _ref => {
  let {
    children,
    ...props
  } = _ref;
  // Just by using this context here, we'll re-render this component when the
  // context value changes. We don't actually need to use anything here,
  // just force a re-render to reposition the portaled menu.
  (0, _LayoutContext.useLayoutContext)();
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.MenuPortal, props, children);
};
exports.MenuPortal = MenuPortal;
//# sourceMappingURL=MenuPortal.js.map